<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Usuarios</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="addModal">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Usuario</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>

              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="search"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>

              <el-select
                class="select-primary pagination-select"
                v-model="role"
                placeholder="Seleccionar rol"
              >
                <el-option
                  class="select-primary"
                  label="Todos"
                  value="todos"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>

              <el-select
                class="select-primary pagination-select"
                v-model="status"
                placeholder="Seleccionar status"
                clearable
              >
                <el-option
                  class="select-primary"
                  label="Activo/Inactivo"
                  value="Activo/Inactivo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Activo"
                  value="Activo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Inactivo"
                  value="Inactivo"
                >
                </el-option>
              </el-select>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="users"
              @sort-change="sortChange"
              empty-text="Sin datos disponibles"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
              <el-table-column label="Agencias">
                <div slot-scope="{ row }" class="table-actions">
                  <div v-if="row.relationships.agencias.data.length">
                    <div v-for="item in row.relationships.agencias.data" :key="item.id">
                      <span>{{item.attributes.nombre}}</span>
                    </div>
                  </div>
                  <span v-else>Sin Agencia</span>
                </div>
              </el-table-column>
              <el-table-column label="Usuario" prop="attributes.username" />
              <el-table-column label="Nombre">
                <div slot-scope="{ row }" class="table-actions">
                  <span>{{row.attributes.name}} {{row.attributes.last_name}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Rol" prop="relationships.role.name" />
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editUser(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button v-if="row.attributes.active" class="hover-apolo" type="primary" icon size="sm" @click="deactivateUser(row)">
                    <span class="btn-inner--text">Desactivar</span>
                  </base-button>
                  <base-button  v-else class="hover-apolo" type="primary" icon size="sm" @click="activateUser(row)">
                    <span class="btn-inner--text">Activar</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear usuario</h6>
        <form class="new-event--form" @submit.prevent="addUser">
          <base-input label="Nombre"
                      placeholder="Nombre del usuario"
                      v-model="user.name"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.name" />
          <base-input label="Apellidos"
                      placeholder="Apellidos del usuario"
                      v-model="user.last_name"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.last_name" />
          <base-input label="Seleccione rol">
            <multiselect v-model="user.role" :options="roles" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione rol" label="name" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.role" />
          <base-input label="Nombre de usuario"
                      placeholder="Usuario del usuario"
                      v-model="user.username"
                      v-on:blur="blurPassword"
                      @input="v => { user.username = v.toUpperCase()}"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.username" />
          <base-input label="Contraseña"
                      placeholder="Contraseña del usuario"
                      v-model="user.password"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.password" />
          <div class="col-12 text-right">
            <span><a @click="generatePassword" style="cursor:pointer;">Aleatorio</a></span>
          </div>
          <br>
          <span>Opcionales:</span>
          <base-input label="Correo electrónico"
                      placeholder="Correo electrónico del usuario"
                      v-model="user.email"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <base-input label="Seleccione agencias">
            <multiselect v-model="user.agencias" :options="agencias" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione agencias" label="nombre" track-by="id" class="agencias" :showLabels="false"></multiselect>
          </base-input>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addUser">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar usuario</h6>
        <form class="new-event--form" @submit.prevent="addUser">
          <base-input label="Nombre"
                      placeholder="Nombre del usuario"
                      v-model="user.name"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.name" />
          <base-input label="Apellidos"
                      placeholder="Apellidos del usuario"
                      v-model="user.last_name"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.last_name" />
          <base-input label="Seleccione rol">
            <multiselect v-model="user.role" :options="roles" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione rol" label="name" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.role" />
          <base-input label="Nombre de usuario"
                      placeholder="Usuario del usuario"
                      v-model="user.username"
                      @input="v => { user.username = v.toUpperCase()}"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.username" />
          <base-input label="Contraseña"
                      placeholder="Contraseña del usuario"
                      v-model="user.password"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.password" />
          <div class="col-12 text-right">
            <span><a @click="generatePassword" style="cursor:pointer;">Aleatorio</a></span>
          </div>
          <br>
          <span>Opcionales:</span>
          <base-input label="Correo electrónico"
                      placeholder="Correo electrónico del usuario"
                      v-model="user.email"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <base-input label="Seleccione agencias">
            <multiselect v-model="user.agencias" :options="agencias" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione agencias" label="nombre" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateUser">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import Multiselect from 'vue-multiselect'
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import ValidationError from "@/components/ValidationError.vue";
  import formMixin from "@/mixins/form-mixin";
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      ValidationError,
      Multiselect,
      Modal,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        users: [],
        roles: [],
        agencias: [],
        selectedRows: [],

        role: null,
        status: null,
        search: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 usuarios por página'},
          {value:'10', descripcion: '10 usuarios por página'},
          {value:'25', descripcion: '25 usuarios por página'},
          {value:'50', descripcion: '50 usuarios por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        user: {
          type: "users",
          username: null,
          name: null,
          last_name: null,
          password: null,
          email: null,
          role: null,
          agencias: [] 
        }
      };
    },

    mounted() {
        this.getRoles();
        this.getAgencias();
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      search: {
        handler: "getListDebounced",
        immediate: true,
      },
      status: {
        handler: "getListDebounced",
        immediate: true,
      },
      role: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },

    },
  
    methods: {
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.search ? { search: this.search } : {}),
            ...(this.status ? { status: this.status } : {}),
            ...(this.role ? { role: this.role } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
        await this.$store.dispatch("users/list", params).then(() => {
          this.users = this.$store.getters["users/list"];
          this.total = this.$store.getters["users/listTotal"];
        });
        this.loading = false;
      },

      async getRoles() {
        let params = {
          filter: {
          },
          page: {
            number: 1,
            size: 100000,
          },
        };
        await this.$store.dispatch("roles/list", params).then(() => {
          this.roles = this.$store.getters["roles/list"];
        });
      },

      async getAgencias() {
        let params = {
          filter: {
          },
          page: {
            number: 1,
            size: 100000,
          },
        };
        await this.$store.dispatch("agencias/list", params).then(() => {
          this.agencias = this.$store.getters["agencias/list"];
        });
      },

      blurPassword(){
        if(this.user.password == null){
          this.user.password = this.user.username;
        }
      },

      generatePassword(){
        this.user.password = Math.random().toString(36).slice(-6);
      },

      addModal(){
        this.user.username = null;
        this.user.password = null;
        this.showAddModal = true;
      },

      closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.user.username = null;
        this.user.name = null;
        this.user.last_name = null;
        this.user.password = null;
        this.user.email = null;
        this.user.role = null;
        this.user.agencias = [];
      },

      async addUser(){
        try {
        await this.$store.dispatch("users/add", this.user);

        this.$notify({
          type: "success",
          message: "Usuario creado satisfactoriamente.",
          duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      editUser(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.user.name = row.attributes.name;
        this.user.last_name = row.attributes.last_name;
        this.user.username = row.attributes.username;
        this.user.email = row.attributes.email;
        this.user.role = this.roles.find(item => item.id == row.relationships.role.id);
        const agencias = [];
        row.relationships.agencias.data.forEach(item => {
          const agencia = item.attributes.nombre;
          if(agencias.includes(agencia) == false){
            agencias.push(agencia);
          }
        });
        this.user.agencias = this.agencias.filter(item => agencias.includes(item.nombre));
        this.user.id = row.id;
        this.user.password = null;
      },

      async updateUser() {
        try{
          await this.$store.dispatch("users/update", this.user);
          this.$notify({
            type: "success",
            message: "Usuario actualizado satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
  
      async activateUser(row) {
        const confirmation = await swal.fire({
          title: `¿Desea activar este usuario?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Activar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("users/activate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Usuario activado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
      async deactivateUser(row) {
        const confirmation = await swal.fire({
          title: `¿Desea desactivar este usuario?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Desactivar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("users/deactivate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Usuario desactivado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>
  <style>
    
  </style>